// extracted by mini-css-extract-plugin
export default {"editorWrapper":"PlainNotes_editorWrapper__3kT5F"};